export type BetId = string | number

export type EmptyPick = -1 | "" | undefined | null

export const isEmptyPick = (pick: any): pick is EmptyPick => {
  return pick === "" || typeof pick === "undefined" || pick === null || pick === ""
} 

export interface BaseBet<BetType = string, PickType = any> {
  bet_type: BetType
  bet_id: BetId
  event_state: "cancelled" | "over" | "open" | "progress"
  event_name: string
  event_date: string
  event_over?: Boolean
  deadline: string
  from_other?: Boolean
  censored?: Boolean
  cancelled?: Boolean
  postponed?: Boolean
  temp_scored?: Boolean
  total_score?: number
  picks?: (PickType | EmptyPick)[]
}

export type PickType<B extends BaseBet> = NonNullable<B["picks"]>[number]

export type WithSecondsLeft<T> = T & {secondsLeft: number}

export type BetEventState = BaseBet["event_state"]
